import { useForm } from 'react-hook-form'
import { AuthData } from "../../pages/Authorization/AuthWrapper";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getAllCategories } from "../../api/category.api";
import OverdueProjectsOption from "./OverdueProjectsOption";
import { isProjectCancelled, isProjectFinished} from '../../services/EnumsService';

// import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom'
import { showSuccess,showError } from '../../services/toastServices';

function OverdueProjectsSectionRightbar() {
    //const { handleSubmit, formState: { errors } } = useForm();
    const[selectedOption, setSelectedOption] = useState('');
    const { user,logoutRefresh } = AuthData();
    const[categories, SetCategories] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        async function loadCategories() {
            if(user.isAuthenticated){
                await getAllCategories(successGetCategories, errorGetCategories);
            }
        }
        loadCategories();
    }, [user])

    const successGetCategories = ((response)=>{
        SetCategories(response.data.items);
    })
    const errorGetCategories = ((error)=>{
        showError('Error al cargar categorías')
    })
    const handleOptionSelection = (to) => {
        setSelectedOption(to)
    }

    const renderLoggedOutUser = (()=>{
        return(
            <div className="text-red-400 font-bold">No ha iniciado sesión.</div>
        )
    })

    const renderCategories = categories
        
        .filter((category) => category.projects.some((project) => project.deadlineStatus > 0 && !isProjectFinished(project) && !isProjectCancelled(project)))
        .map((category) => {
            return (
                <div key={`rb-ct-${category.id}`} className="mb-6">
                    {/* Header de categoría (opcional) */}
                    <h3 className="font-bold text-lg mb-2">{category.name}</h3>
                    
                    {/* Proyectos de esta categoría */}
                    {category.projects.sort((a,b) => b.deadlineStatus - a.deadlineStatus).map((project) => {
                        if(project.deadlineStatus <= 0 || isProjectCancelled(project) || isProjectFinished(project)) return null;
                        return (
                        <OverdueProjectsOption
                            key={`rb-pj-${project.id}`}
                            to={`/category-projects/${category.id}/project/${project.id}`}
                            editTo={`/category/${category.id}`}
                            project={project}
                            className="mb-3"
                            activeClassName="font-bold border-l-4 border-black pl-2"
                            handleOptionSelection={handleOptionSelection}
                            selected={selectedOption}
                        />
                        );
                    })}
                </div>
            );
        });    

    const renderContent = (() => {
        return (
            <div className="flex flex-col bg-gray-100 rounded-lg p-2 w-full">
                <div className="w-full grid grid-cols-5 mt-1">
                    <div className="font-bold col-span-5 text-lg mb-2">Deadlines críticos</div>
                </div>
                <div className="grid grid-cols-1 ml-2">
                    {user.isAuthenticated ? renderCategories:renderLoggedOutUser()}
                </div>
            </div>
        )
    })

    return (
        <div className="sticky top-0 overflow-auto scrollbar-hide flex flex-col items-start">
            {renderContent()}
        </div>
    )
};

export default OverdueProjectsSectionRightbar;